/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import * as React from 'react';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { withNotifications } from '@components/hoc/withNotifications';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { InputField, Input, DateField, Date } from '@components/form';
import { crrLookupPersonalData, crrLookupDrivingLicence } from '@modules/wantedPersons/_wantedPersonsActions';
import { change, formValueSelector, reduxForm } from 'redux-form';
import { ModalButton } from '@components/modalButton/ModalButton';
import PersonIcon from 'material-ui/svg-icons/social/person';
import { connect } from 'react-redux';

const validateData = ({ firstName, lastName, birthDate, licenceNumber }) =>
  (firstName && lastName && birthDate) || licenceNumber;

const enhanceModal = compose<any, any>(
  withState('showError', 'handleShowError', false),
  withNotifications({ crrLookupPersonalData, crrLookupDrivingLicence }),
  withHandlers({
    onSubmit: ({
      handleLoader,
      crrLookupPersonalDataNotify,
      crrLookupDrivingLicenceNotify,
      handleShowError,
      changeFieldValue,
      updateIdentifications,
      identifications,
      closeItem
    }) => async formData => {
      handleLoader(true);
      const isValid = validateData(formData);

      handleShowError(!isValid);

      if (!isValid) {
        handleLoader(false);
        return;
      }

      const { firstName, lastName, birthDate, licenceNumber } = formData;

      const response =
        firstName && lastName && birthDate
          ? await crrLookupPersonalDataNotify({ firstName, lastName, birthDate })
          : await crrLookupDrivingLicenceNotify(licenceNumber);

      if (response) {
        for (const attribute of Object.keys(response)) {
          if (attribute === 'identifications') {
            updateIdentifications(identifications, response[attribute]);
          } else {
            changeFieldValue(attribute, response[attribute]);
          }
        }
      }

      closeItem();
      handleLoader(false);
    }
  }),
  reduxForm({
    form: 'module-crr-lookup'
  })
);

const CrrModal: React.SFC<any> = ({ closeItem, handleSubmit, showError }) => (
  <div style={{ margin: '15px' }}>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <h4>Lustrace řidiče</h4>
        </Row>
        <Row>
          {[{ label: 'Jméno', name: 'firstName' }, { label: 'Příjmení', name: 'lastName' }].map(({ label, name }) => (
            <Col md={4} key={name}>
              <InputField component={Input} name={name} label={label} />
            </Col>
          ))}
          <Col md={4}>
            <DateField component={Date} name={'birthDate'} label={'Datum narození'} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputField component={Input} name={'licenceNumber'} label={'Číslo řidičského průkazu'} />
          </Col>
        </Row>

        {showError && (
          <Row>
            <h5 style={{ color: 'red' }}>Vyplňte osobní údaje nebo číslo řidičského průkazu</h5>
          </Row>
        )}
      </Grid>

      <Button label={'Lustrovat'} type="submit" primary={true} style={{ margin: '15px' }} />
      <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
    </form>
  </div>
);

const enhance = compose<any, any>(
  withState('showError', 'handleShowError', false),
  connect<any>(
    (state, { form, formName = '' }: any) => {
      return {
        firstName: formValueSelector(form)(state, `${formName}firstName`),
        lastName: formValueSelector(form)(state, `${formName}lastName`),
        birthDate: formValueSelector(form)(state, `${formName}birthDate`),
        identifications: formValueSelector(form)(state, `${formName}identifications`)
      };
    },
    (dispatch, { form, formName = '' }: any) => ({
      changeFieldValue: (label, value) => dispatch(change(form, `${formName}${label}`, value)),
      updateIdentifications: (prev, value) => {
        if (Array.isArray(value)) {
          return dispatch(change(form, `${formName}identifications`, [...prev, ...value]));
        }
        return dispatch(change(form, `${formName}identifications`, [...prev, value]));
      }
    })
  ),
  withProps(({ firstName, lastName, birthDate }) => {
    return {
      initialValues: {
        firstName,
        lastName,
        birthDate
      }
    };
  })
);

const CrrSection: React.SFC<any> = ({ initialValues, changeFieldValue, updateIdentifications, identifications }) => (
  <div
    style={{
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'row'
    }}
  >
    <h4>Informace o řidiči</h4>
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline'
      }}
    >
      <ModalButton
        {...{
          label: 'Lustrace řidiče',
          icon: <PersonIcon />,
          style: { marginBottom: 10, marginRight: 10 },
          ModalComponent: enhanceModal(CrrModal),
          initialValues,
          changeFieldValue,
          updateIdentifications,
          identifications
        }}
      />
    </div>
  </div>
);

export default enhance(CrrSection);



// WEBPACK FOOTER //
// ./src/components/person/CrrForm.tsx